package org.luxons.sevenwonders.ui.components.home

import csstype.*
import emotion.css.*
import web.cssom.*

object HomeStyles {

    val centerChildren = ClassName {
        display = Display.flex
        flexDirection = FlexDirection.column
        alignItems = AlignItems.center
        justifyContent = JustifyContent.center
    }
}
